module.exports = __webpack_public_path__ + "media/images/corporate-logos/logo-nasa-5834faa98f78a7231a3fe0f1ed8970a0.svg";